import React, { useState, useRef, useEffect } from 'react';
import '../styles/platformsDropdown.css';

const PlatformsDropdown = ({ 
  youtubeFilter, 
  twitchFilter, 
  kickFilter,
  epgFilter,
  youtubeCount,
  twitchCount,
  kickCount,
  epgCount,
  onToggleYoutube,
  onToggleTwitch,
  onToggleKick,
  onToggleEpg
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const selectedCount = [youtubeFilter, twitchFilter, kickFilter, epgFilter].filter(Boolean).length;

  return (
    <div className="platforms-dropdown-container" ref={dropdownRef}>
      <button
        className="platforms-dropdown-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <span>Platforms</span>
        <svg 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
          className={`dropdown-icon ${isOpen ? 'open' : ''}`}
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
        {selectedCount > 0 && (
          <span className="selected-badge">{selectedCount}</span>
        )}
      </button>

      {isOpen && (
        <div className="platforms-card">
          <div className="platforms-card-content">
            <div className="platform-item">
            <label className="platform-checkbox-label">
              <input
                type="checkbox"
                checked={youtubeFilter}
                onChange={onToggleYoutube}
                className="platform-checkbox"
              />
              <span className="checkbox-custom"></span>
              <svg viewBox="0 0 24 24" fill="none" width="20" height="20" className="platform-icon" style={{ color: '#FF0000' }}>
                <path d="M23.498 6.186a2.994 2.994 0 0 0-2.108-2.116C19.228 3.5 12 3.5 12 3.5s-7.228 0-9.39.57A2.994 2.994 0 0 0 .502 6.186C0 8.36 0 12 0 12s0 3.64.502 5.814a2.994 2.994 0 0 0 2.108 2.116C4.772 20.5 12 20.5 12 20.5s7.228 0 9.39-.57a2.994 2.994 0 0 0 2.108-2.116C24 15.64 24 12 24 12s0-3.64-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="currentColor"/>
              </svg>
              <span className="platform-label-text">YouTube</span>
              <span className="platform-count">{youtubeCount} streams</span>
            </label>
          </div>

          <div className="platform-item">
            <label className="platform-checkbox-label">
              <input
                type="checkbox"
                checked={twitchFilter}
                onChange={onToggleTwitch}
                className="platform-checkbox"
              />
              <span className="checkbox-custom"></span>
              <svg viewBox="0 0 24 24" fill="none" width="20" height="20" className="platform-icon" style={{ color: '#9146FF' }}>
                <path d="M2.857 0L.286 4.286V21.43h5.143V24h3.429l3.429-2.571h4.286L23.714 16V0H2.857zm17.143 15.429l-2.571 2.571h-4.286l-3.429 2.571v-2.571H3.429V1.714h16.571v13.715z" fill="currentColor"/>
                <path d="M17.143 6.857h-1.714v5.143h1.714V6.857zm-4.286 0h-1.714v5.143h1.714V6.857z" fill="currentColor"/>
              </svg>
              <span className="platform-label-text">Twitch</span>
              <span className="platform-count">{twitchCount} streams</span>
            </label>
          </div>

          <div className="platform-item">
            <label className="platform-checkbox-label">
              <input
                type="checkbox"
                checked={kickFilter}
                onChange={onToggleKick}
                className="platform-checkbox"
              />
              <span className="checkbox-custom"></span>
              <svg viewBox="0 0 24 24" fill="none" width="20" height="20" className="platform-icon" style={{ color: '#53FC18' }}>
                <path d="M3 3h5.2v6.2L14.5 3H21l-7.1 7.4L21 21h-6.6l-6.2-7.8V21H3V3z" fill="currentColor"/>
              </svg>
              <span className="platform-label-text">Kick</span>
              <span className="platform-count">{kickCount} streams</span>
            </label>
          </div>

          <div className="platform-item">
            <label className="platform-checkbox-label">
              <input
                type="checkbox"
                checked={epgFilter}
                onChange={onToggleEpg}
                className="platform-checkbox"
              />
              <span className="checkbox-custom"></span>
              <svg viewBox="0 0 24 24" fill="none" width="20" height="20" className="platform-icon" style={{ color: '#4ade80' }}>
                <rect x="2" y="6" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
                <path d="m8 2 4 4 4-4" stroke="currentColor" strokeWidth="2" />
              </svg>
              <span className="platform-label-text">Live TV</span>
              <span className="platform-count">{epgCount} events</span>
            </label>
          </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlatformsDropdown;



